export const TIMESERIES_X_EXTENTS = [2009,2019]
export const TIMESERIES_Y_EXTENTS = [-2, 2]